export enum FrameworkUserRole {
    ANONYMOUS = 'anonymous', // Not logger in user session has this role
    USER = 'user', // Every logged in user has this role
    ADMIN = 'admin', // Administrator
    MANAGER = 'manager', // Space manager
    EDITOR = 'editor', // Space editor
    VIEWER = 'viewer', // Space viewer
    NODE = 'node', // Application user
}
